import { render } from "./LanguagesView.vue?vue&type=template&id=4202bcc0&scoped=true&lang=html"
import script from "./LanguagesView.vue?vue&type=script&lang=js"
export * from "./LanguagesView.vue?vue&type=script&lang=js"

import "./LanguagesView.vue?vue&type=style&index=0&id=4202bcc0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4202bcc0"]])

export default __exports__